import React, { useState, useEffect, useContext, useRef, createRef } from "react";
import { Col, Container, Form, Modal, Row, Table } from "react-bootstrap";
import Context from "../../../../context/Context";
import Button from "@mui/material/Button";
import blogFetch from "../../../../axios/config";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { DateTimeFmt } from "../../../../utils/DataUtils";
import './styles.css'
import { Input } from "@mui/base";
import toast from "react-hot-toast";
import Navbar from "../../../../layout/Navbar/Navbar";
import Sidebar from "../../../../layout/Sidebar/SideBar";
import { getCookie } from "../../../../section/cookie";
import Loading from "../../../../components/Loading";

const SAVE_VALUE = {
  Apont_Key: 0,
  Ordem_Serial: "",
  Chave_Modelo: null,
  Maquina: null,
  Origem_Cod: null,
  Grupo_Defeito_Cod: null,
  Defeito_Cod: null,
  Causa_Cod: null,
  Observacao: "",
  Lote: "",
  Corte_Manual: false,
  Duplo_Corte: false
}

export const FormApont = ({
}) => {

  const [machine, setMachine] = useState([]);
  const [origins, setOrigins] = useState([]);
  const [groupDefects, setGroupDefects] = useState([]);
  const [defects, setDefects] = useState([]);
  const [causes, setCauses] = useState([]);
  const [keyModel, setKeyModel] = useState([]);
  const [motivo, setMotivo] = useState([]);
  const [apontamentos, setApontamentos] = useState([]);
  const [carDesc, setCarDesc] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [filtroOrdem, setFiltroOrdem] = useState('');
  const [saveItems, setSaveItems] = useState(SAVE_VALUE);
  const [verify, setVerify] = useState(null);
  const [loadingField, setLoadingField] = useState(false);
  const [showCorteModal, setShowCorteModal] = useState(false);
  const [bipCorte, setBipCorte] = useState("");
  const bipInputRef = useRef(null);

  const [filtros, setFiltros] = useState({
    ordem: "",
    chave: "",
    defeito: "",
    status: "",
    corteManual: "",
    espessura: ""
  });


  const cookie = getCookie("permissions")




  const {
    getStatusSideBar,
    parts
  } = useContext(Context);

  useEffect(() => {
    GetMotivo();
    if (saveItems.Origem_Cod) {
      GetGroupDefectByOrigin(saveItems.Origem_Cod.cod_Origem);
    };
    if (saveItems.Grupo_Defeito_Cod) {
      GetDefectByGroupDefect(saveItems.Origem_Cod.cod_Origem, saveItems.Grupo_Defeito_Cod.cod_Grupo_Defeitos);
    };
    if (saveItems.Defeito_Cod) {
      GetCausesByDefect(saveItems.Origem_Cod.cod_Origem, saveItems.Grupo_Defeito_Cod.cod_Grupo_Defeitos, saveItems.Defeito_Cod.cod_Defeito);
    };

  }, [saveItems.Origem_Cod, saveItems.Grupo_Defeito_Cod, saveItems.Defeito_Cod]);

  useEffect(() => {
    GetApontamentos()
  }, []);

  const getVerifyParts = async (ordem) => {
    try {
      const { data } = await blogFetch.get(`/SAGAViewPecasSetor/Ordem?ordem=${ordem}`);
      setVerify(data);
      if (data === true)
        toast.error("Não é possível criar reprocesso para peça que já estão depois de 06CURVAD", {
          duration: 4000,
        });
    } catch {
      console.error("Error");
    }

  };

  const onChange = (name, value) => {
    setSaveItems({
      ...saveItems,
      [name]: value
    });
    switch (name) {
      case 'Origem_Cod':
        setSaveItems({
          ...saveItems,
          [name]: value,
          Grupo_Defeito_Cod: null,
          Defeito_Cod: null,
          Causa_Cod: null,
        });
        break;
      case 'Grupo_Defeito_Cod':
        setSaveItems({
          ...saveItems,
          [name]: value,
          Defeito_Cod: null,
          Causa_Cod: null,
        });
        break;
      case 'Defeito_Cod':
        setSaveItems({
          ...saveItems,
          [name]: value,
          Causa_Cod: null,
        });
        break;
      default:
        setSaveItems({
          ...saveItems,
          [name]: value,
        });
    }
  };

  const handleFiltroChange = (coluna, valor) => {
    setFiltros({
      ...filtros,
      [coluna]: valor
    });
  };


  const apontamentosFiltrados = apontamentos.filter(item => {
    return (
      item.iApont_OrdemSerial?.toLowerCase().includes(filtros.ordem.toLowerCase()) &&
      item.iApont_Lite?.toLowerCase().includes(filtros.chave.toLowerCase()) &&
      item.iApont_Defeito?.toLowerCase().includes(filtros.defeito.toLowerCase()) &&
      item.iApont_Status?.toLowerCase().includes(filtros.status.toLowerCase()) &&
      (filtros.corteManual === ""
        ? true
        : filtros.corteManual === "SIM"
          ? item.iApont_ManualCutting
          : !item.iApont_ManualCutting) &&
      (item.iApont_Espessura?.toString() || "").includes(filtros.espessura)
    );
  });

  const clearSelected = () => {
    setIsEdit(false)
    setCarDesc("")
    setSaveItems(SAVE_VALUE);
  };

  const GetMotivo = async () => {
    try {
      const { data } = await blogFetch.get(`/ISAGA_MoldePendenciasMotivo`);
      setMotivo(data);
    } catch (error) {
      console.error(error);
    };
  };

  const GetModelKeysByOrderAndSector = async (ordem, setor) => {
    try {
      const { data } = await blogFetch.get(
        `/Desenho?order=${ordem}&sector=${setor}`
      );
      setKeyModel(data);
      return data;
    } catch (error) {
      console.error(error);
    };
  };

  const GetMachines = async () => {
    try {
      const { data } = await blogFetch.get(`/Machine`);
      setMachine(data);
      return data
    } catch (error) {
      console.error(error);
    }
  };

  const GetOriginBySector = async () => {
    try {
      const { data } = await blogFetch.get(`/CatalogoDefeitos/Origin/01CORTE`);
      setOrigins(data);
      return data
    } catch (error) {
      console.error(error);
    };
  };

  const GetGroupDefectByOrigin = async (origem) => {
    try {
      const { data } = await blogFetch.get(
        `/CatalogoDefeitos/GroupDefect?origin=${origem}&sector=01CORTE`
      );
      setGroupDefects(data);
      return data
    } catch (error) {
      console.error(error);
    };
  };

  const GetDefectByGroupDefect = async (origem, grupoDefeito) => {
    try {
      const { data } = await blogFetch.get(
        `/CatalogoDefeitos/Defect?origin=${origem}&sector=01CORTE&grupoDefeito=${grupoDefeito}`
      );
      setDefects(data);
      return data
    } catch (error) {
      console.error(error);
    };
  };

  const GetCausesByDefect = async (origem, grupoDefeito, defeito) => {
    try {
      const { data } = await blogFetch.get(
        `/CatalogoDefeitos/Cause?defect=${defeito}&origin=${origem}&sector=01CORTE&grupoDefeito=${grupoDefeito}`
      );
      setCauses(data);
      return data
    } catch (error) {
      console.error(error);
    };
  };

  const GetViewDescVeichleByOrdem = async (param) => {
    try {
      const { data } = await blogFetch.get(
        `/SAGAViewDescVeiclePecaShort/${param}`
      );
      setCarDesc(data);
    } catch (error) {
      console.error(error);
    }
    GetModelKeysByOrderAndSector(param, "01CORTE");
    GetMachines();
    GetOriginBySector();
  };

  const GetApontamentos = async () => {
    try {
      let response = await blogFetch.get(`/ApontamentosISaga`);
      let data = response.data;
      setApontamentos(data);
    } catch (error) {
      console.error(error);
    }
  };

  const findApont = (key, item, value) => {
    const found = item.find((apontamento) => apontamento[key] === value)
    return found
  };

  const handleEditApontamento = async (item) => {
    setIsEdit(true);
    try {
      const [
        keyModelVar,
        MaquinaVar,
        OrigemCod,
        GrupoDefeitoCod,
        DefeitoCod,
        CausaCod,
      ] = await Promise.all([
        GetModelKeysByOrderAndSector(item.iApont_OrdemSerial, "01CORTE"),
        GetMachines(),
        GetOriginBySector(),
        GetGroupDefectByOrigin(item.iApont_OrigemCod),
        GetDefectByGroupDefect(item.iApont_OrigemCod, item.iApont_GrupoDefeitoCod),
        GetCausesByDefect(item.iApont_OrigemCod, item.iApont_GrupoDefeitoCod, item.iApont_DefeitoCod),
      ])
      setSaveItems({
        ...saveItems,
        Apont_Key: item.iApont_Key,
        Ordem_Serial: item.iApont_OrdemSerial,
        Chave_Modelo: findApont("desenho_ClaveModelo", keyModelVar, item.iApont_Lite),
        Maquina: findApont("machine_Name", MaquinaVar, item.iApont_Machine),
        Origem_Cod: findApont("cod_Origem", OrigemCod, item.iApont_OrigemCod),
        Grupo_Defeito_Cod: findApont("cod_Grupo_Defeitos", GrupoDefeitoCod, item.iApont_GrupoDefeitoCod),
        Defeito_Cod: findApont("cod_Defeito", DefeitoCod, item.iApont_DefeitoCod),
        Causa_Cod: findApont("cod_Causa", CausaCod, item.iApont_CausaCod),
        Observacao: item.iApont_Observacao,
        Lote: item.iApont_Lote,
        Corte_Manual: item.iApont_ManualCutting,
      });
    } catch (error) {
      console.error("Erro ao editar apontamento:", error);
    } finally {

    }
  };


  const validarCampos = (item) => {
    const camposObrigatorios = [
      { valor: item.Ordem_Serial?.toString().trim(), label: "Ordem" },
      { valor: item.Chave_Modelo, label: "Chave Modelo" },
      { valor: item.Maquina, label: "Maquina" },
      { valor: item.Origem_Cod, label: "Origem" },
      { valor: item.Grupo_Defeito_Cod, label: "Grupo Defeito" },
      { valor: item.Defeito_Cod, label: "Defeito" },
      { valor: item.Causa_Cod, label: "Causa" },
    ];

    const faltando = camposObrigatorios
      .filter((campo) => !campo.valor)
      .map((campo) => campo.label);

    return faltando;
  };

  const buildPayload = (item) => ({
    iApont_Machine: item.Maquina.machine_Name,
    iApont_OrdemSerial: item.Ordem_Serial.trim(),
    iApont_Lite: item.Chave_Modelo.desenho_ClaveModelo,
    iApont_Tipo: "Reprocesso",
    iApont_GrupoDefeitoCod: item.Grupo_Defeito_Cod.cod_Grupo_Defeitos,
    iApont_GrupoDefeito: item.Grupo_Defeito_Cod.grupo_Defeito,
    iApont_DefeitoCod: item.Defeito_Cod.cod_Defeito,
    iApont_Defeito: item.Defeito_Cod.defeito,
    iApont_OrigemCod: item.Origem_Cod.cod_Origem,
    iApont_Origem: item.Origem_Cod.origem,
    iApont_CausaCod: item.Causa_Cod.cod_Causa,
    iApont_Causa: item.Causa_Cod.causa,
    iApont_Observacao: item.Observacao,
    iApont_Lote: item.Lote,
    iApont_RPStatus: "",
    iApont_APStatus: "",
    iApont_ManualCutting: item.Corte_Manual,
    iApont_DuploCorte: item.Duplo_Corte,
    iApont_Origem_Setor: item.Origem_Cod.origem_Setor,
    iApont_Status: "ABERTO"
  });

  const handleApont = async (item, isEdit) => {
    const camposFaltando = validarCampos(item);
    if (camposFaltando.length > 0) {
      toast.error(`Preencha os campos obrigatórios: ${camposFaltando.join(", ")}`, {
        duration: 4000,
      });
      return;
    }

    if (!isEdit) {
      const ordem = item.Ordem_Serial.trim();
      const chaveModelo = item.Chave_Modelo.desenho_ClaveModelo;
      const conflito = apontamentos.find(
        (a) =>
          a.iApont_OrdemSerial === ordem &&
          a.iApont_Lite === chaveModelo &&
          (a.iApont_Status === "ABERTO" || a.iApont_Status === "REPROCESSADO")
      );
      if (conflito) {
        toast.error(
          "Já existe um reprocesso em aberto/reprocessado para esta ordem e chave modelo. Não é possível abrir outro até que a peça seja cortada (status APROVADO).",
          { duration: 5000 }
        );
        return;
      }
    }

    const payload = buildPayload(item);
    if (!isEdit) {
      try {
        await blogFetch.post("/ApontamentosISaga", payload)
        clearSelected();
        GetApontamentos();
        toast.success("Reprocesso cadastrado com sucesso", {
          duration: 4000,
        });
      } catch {
        toast.error("Erro ao cadastrar o reprocesso", {
          duration: 4000,
        });
        console.error("error")
      }
    } else {
      try {
        await blogFetch.put(`/ApontamentosISaga/${item.Apont_Key}`, payload);
        clearSelected();
        GetApontamentos();
        toast.success("Reprocesso atualizado com sucesso", {
          duration: 4000,
        });
      } catch {
        toast.error("Erro ao atualizar o reprocesso", {
          duration: 4000,
        });
        console.error("error")
      }
    }
    setIsEdit(false)
  }

  const putFinalizarApont = async (item) => {
    try {
      await blogFetch.put(`/ApontamentosISaga/finalizar/${item.Apont_Key}`,);
      clearSelected();
      GetApontamentos();
      toast.success("Reprocesso finalizado com sucesso", {
        duration: 4000,
      });
    } catch {
      toast.error("Erro ao finaliar o reprocesso", {
        duration: 4000,
      });
      console.error("error")
    }

    setIsEdit(false)
  }

  const handleBipCorte = async (valor) => {
    const texto = (valor || "").trim();
    if (!texto) return;

    // Formato esperado do bip: "11280404 - 01VEXTU"
    const separador = texto.indexOf("-");
    const ordem = separador === -1 ? "" : texto.slice(0, separador).trim();
    const chave = separador === -1 ? "" : texto.slice(separador + 1).trim();

    if (!ordem || !chave) {
      toast.error("Bip inválido. Formato esperado: ORDEM - CHAVE MODELO", {
        duration: 3000,
      });
      setBipCorte("");
      return;
    }

    try {
      await blogFetch.put(`/ApontamentosISaga/cortar`, {
        iApont_OrdemSerial: ordem,
        iApont_Lite: chave,
      });
      GetApontamentos();
      toast.success(`Corte apontado: ${ordem} - ${chave}`, {
        duration: 3000,
      });
    } catch (error) {
      const mensagem =
        error?.response?.data?.message ||
        `Erro ao apontar corte: ${ordem} - ${chave}`;
      toast.error(mensagem, {
        duration: 4000,
      });
      console.error(error);
    } finally {
      setBipCorte(""); // limpa para a próxima peça
      bipInputRef.current?.focus(); // devolve o foco para bipar a próxima
    }
  }

  const deleteApont = async (item) => {
    try {
      await blogFetch.delete(`/ApontamentosISaga/${item.Apont_Key}`);
      clearSelected();
      GetApontamentos();
      toast.success("Reprocesso deletado com sucesso", {
        duration: 4000,
      });
    } catch {
      toast.error("Erro ao deletar o reprocesso", {
        duration: 4000,
      });
      console.error("error")
    }
    setIsEdit(false)
  }



  return (
    <>
      <div className={`app_body ${getStatusSideBar()}`}>

        <Container fluid className="p-0 m-0">
          <Row className="p-3">
            <Col lg={3} md={5} sm={12} className="border-end pe-3">
              <h2 className="title_tables">
                APONTAR REPROCESSO
              </h2>
              <TextField className="mb-3 me-2"
                fullWidth
                value={saveItems.Ordem_Serial}
                id="outlined-basic"
                label="Ordem"
                variant="outlined"
                disabled={isEdit}
                onChange={(event) => {
                  setSaveItems({
                    ...saveItems,
                    Ordem_Serial: event.target.value
                  })
                }}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === "Done") {
                    GetViewDescVeichleByOrdem(event.target.value)
                    getVerifyParts(event.target.value)
                  }
                }}
              />

              {carDesc && (
                <p>{`${carDesc.ordem_Serial} - ${carDesc.ordem_VehDesc} - ${carDesc.peca_Short}`}</p>
              )}

              <Autocomplete className="mb-3"
                id="tags-outlined"
                options={keyModel}
                getOptionLabel={(option) => option.desenho_ClaveModelo}
                value={saveItems.Chave_Modelo}
                onChange={(_, value) => onChange("Chave_Modelo", value)}
                disabled={!saveItems.Ordem_Serial || isEdit || verify}
                filterSelectedOptions
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" label="Chave Modelo"
                  />
                )}
              />

              <Autocomplete className="mb-3"
                id="tags-outlined"
                options={machine}
                getOptionLabel={(option) => option.machine_Name}
                value={saveItems.Maquina}
                onChange={(_, value) => onChange("Maquina", value)}
                disabled={!saveItems.Chave_Modelo}
                filterSelectedOptions
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" label="Maquina" />
                )}
              />

              <Autocomplete className="mb-3"
                id="tags-outlined"
                options={origins}
                getOptionLabel={(option) => `${option.cod_Origem} (${option.origem_Setor})`}
                value={saveItems.Origem_Cod}
                onChange={(_, value) => onChange("Origem_Cod", value)}
                disabled={!saveItems.Maquina}
                filterSelectedOptions
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" label="Origem" />
                )}
              />

              <Autocomplete className="mb-3"
                id="tags-outlined"
                options={groupDefects}
                getOptionLabel={(option) => `${option.cod_Grupo_Defeitos} (${option.grupo_Defeito})`}
                value={saveItems.Grupo_Defeito_Cod}
                onChange={(_, value) => onChange("Grupo_Defeito_Cod", value)}
                disabled={!saveItems.Origem_Cod}
                filterSelectedOptions
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" label="Grupo Defeito" />
                )}
              />

              <Autocomplete className="mb-3"
                id="tags-outlined"
                options={defects}
                getOptionLabel={(option) => `${option.cod_Defeito} (${option.defeito})`}
                value={saveItems.Defeito_Cod}
                onChange={(_, value) => onChange("Defeito_Cod", value)}
                disabled={!saveItems.Grupo_Defeito_Cod}
                filterSelectedOptions
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" label="Defeito" />
                )}
              />

              <Autocomplete className="mb-3"
                id="tags-outlined"
                options={causes}
                getOptionLabel={(option) => `${option.causa} (${option.cod_Causa})`}
                value={saveItems.Causa_Cod}
                onChange={(_, value) => onChange("Causa_Cod", value)}
                disabled={!saveItems.Defeito_Cod}
                filterSelectedOptions
                renderInput={(params) => (
                  <TextField {...params} variant="outlined" label="Causa" />
                )}
              />

              <TextField className="mb-3"
                fullWidth
                disabled={!saveItems.Causa_Cod}
                value={saveItems.Lote}
                id="outlined-basic"
                label="Lote de Consumo"
                variant="outlined"
                onChange={(event) => {
                  setSaveItems({
                    ...saveItems,
                    Lote: event.target.value
                  })
                }}
              />

              <TextField className="mb-3"
                fullWidth
                value={saveItems.Observacao}
                disabled={!saveItems.Causa_Cod}
                id="outlined-basic"
                label="Observação"
                variant="outlined"
                onChange={(event) => {
                  setSaveItems({
                    ...saveItems,
                    Observacao: event.target.value
                  })
                }}
              />


              <Form className="p-2">
                <Form.Check
                  type="checkbox"
                  checked={saveItems.Corte_Manual}
                  label="Corte Manual?"
                  onClick={() => {
                    setSaveItems({
                      ...saveItems,
                      Corte_Manual: !saveItems.Corte_Manual
                    })
                  }}
                />
              </Form>

              <div className="d-flex justify-content-end">
                <Button className="me-3"
                  variant="contained"
                  onClick={clearSelected}
                >
                  LIMPAR
                </Button>

                {cookie.includes("Reprocesso_btn_finalizar") && (
                  <Button
                    className="me-3"
                    onClick={() => putFinalizarApont(saveItems)}
                    variant="contained"
                    disabled={verify}

                  >
                    FINALIZAR
                  </Button>
                )}


                <Button
                  className="me-3"
                  onClick={() => deleteApont(saveItems)}
                  variant="contained"
                  color="error"
                  disabled={verify}
                >

                  EXCLUIR
                </Button>

                <Button
                  className="me-3"
                  onClick={() => handleApont(saveItems, isEdit)}
                  variant="contained"
                  disabled={!saveItems.Causa_Cod || verify}

                >
                  SALVAR
                </Button>
              </div>

            </Col>
            <Col lg={9} md={8} sm={12}>
              <div className="d-flex justify-content-end m-2">
                <Button
                  variant="contained"
                  color="success"
                  onClick={() => setShowCorteModal(true)}
                >
                  APONTAR CORTE
                </Button>
              </div>
              <div className="table-fixed flex flex-1 text-center justify-center m-2">
                <h1 className="">
                  REPROCESSOS
                </h1>
                {/* <Input
                    placeholder="Ordem"
                    onChange={(e) => handleFiltroChange(e.target.value)}
                  /> */}
                <div className="table filawrap">
                  <Table bordered hover responsive size="lg" className="shadow-sm m-2">
                    <thead>
                      <tr>
                        <th>DATA-HORA</th>
                        <th>ORDEM</th>
                        <th>CHAVE</th>
                        <th>DEFEITO</th>
                        <th>CORTE MANUAL</th>
                        <th>STATUS</th>
                        <th>ESPESSURA</th>
                      </tr>
                      <tr>
                        <th></th>
                        <th>
                          <Input
                            placeholder="Filtrar Ordem"
                            value={filtros.ordem}
                            onChange={(e) => handleFiltroChange("ordem", e.target.value)}
                          />
                        </th>
                        <th>
                          <Input
                            placeholder="Filtrar Chave"
                            value={filtros.chave}
                            onChange={(e) => handleFiltroChange("chave", e.target.value)}
                          />
                        </th>
                        <th>
                          <Input
                            placeholder="Filtrar Defeito"
                            value={filtros.defeito}
                            onChange={(e) => handleFiltroChange("defeito", e.target.value)}
                          />
                        </th>
                        <th>
                          <select
                            value={filtros.corteManual}
                            onChange={(e) => handleFiltroChange("corteManual", e.target.value)}
                          >
                            <option value="">Todos</option>
                            <option value="SIM">SIM</option>
                            <option value="NÃO">NÃO</option>
                          </select>
                        </th>
                        <th>
                          <Input
                            placeholder="Filtrar Status"
                            value={filtros.status}
                            onChange={(e) => handleFiltroChange("status", e.target.value)}
                          />
                        </th>
                        <th>
                          <Input
                            placeholder="Filtrar Espessura"
                            value={filtros.espessura}
                            onChange={(e) => handleFiltroChange("espessura", e.target.value)}
                          />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {apontamentosFiltrados.map((item, index) => (
                        <tr
                          key={index}
                          onClick={() => {
                            if (item.iApont_Status === "ABERTO" || item.iApont_Status === "REPROCESSADO" || item.iApont_Status === "APROVADO") {
                              handleEditApontamento(item);
                            }
                            clearSelected()
                            setIsEdit(true)
                          }}
                        >
                          <td className="p-0 h6 table-reprocess-body">{DateTimeFmt(item._ts_Creat)}</td>
                          <td className="p-0 h6">{item.iApont_OrdemSerial}</td>
                          <td className="p-0 h6 table-reprocess-body">{item.iApont_Lite}</td>
                          <td className="p-0 h6 table-reprocess-body">{item.iApont_Defeito}</td>
                          <td className="p-0 h6 table-reprocess-body">{item.iApont_ManualCutting ? "SIM" : "NÃO"}</td>
                          <td className="p-0 h6">{item.iApont_Status}</td>
                          <td className="p-0 h6">{item.iApont_Espessura ? item.iApont_Espessura : ""}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal
        show={showCorteModal}
        onHide={() => {
          setShowCorteModal(false);
          setBipCorte("");
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Apontar Corte</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TextField
            fullWidth
            autoFocus
            inputRef={bipInputRef}
            value={bipCorte}
            label="Bipe a ordem"
            placeholder="Ex: 11280404 - 01VEXTU"
            variant="outlined"
            onChange={(event) => setBipCorte(event.target.value)}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === "Done") {
                event.preventDefault();
                handleBipCorte(bipCorte);
              }
            }}
          />
        </Modal.Body>
      </Modal>
    </>
  );
}